/**
 * uiStorage — the ONLY place the app touches localStorage/sessionStorage.
 *
 * Policy: non-sensitive UI state only (dismiss flags, currency, A/B bucket,
 * a pasted ad script in transit). Auth lives in an httpOnly cookie set by the
 * backend — never put tokens, keys or personal data here. Every call is
 * wrapped because Safari Private Mode / quota errors throw.
 */
export const isDev = process.env.NODE_ENV !== "production";

/** Session flag: first-login onboarding goal modal was answered/skipped. */
export const ONBOARDING_DISMISSED_KEY = "lumora_onboarding_dismissed_v1";

/** Dev-only warn: visible while developing, silent for customers' DevTools. */
export const devWarn = (...args) => { if (isDev) console.warn(...args); };

function area(session) {
  return session ? window.sessionStorage : window.localStorage;
}

export function storageGet(key, { session = false } = {}) {
  if (typeof window === "undefined") return null;
  try { return area(session).getItem(key); }
  catch (err) { devWarn(`uiStorage: read failed for ${key}`, err); return null; }
}

export function storageSet(key, value, { session = false } = {}) {
  if (typeof window === "undefined") return false;
  try { area(session).setItem(key, value); return true; }
  catch (err) { devWarn(`uiStorage: write failed for ${key}`, err); return false; }
}

export function storageRemove(key, { session = false } = {}) {
  if (typeof window === "undefined") return;
  try { area(session).removeItem(key); }
  catch (err) { devWarn(`uiStorage: remove failed for ${key}`, err); }
}

export function storageGetJSON(key, options) {
  const raw = storageGet(key, options);
  if (!raw) return null;
  try { return JSON.parse(raw); }
  catch (err) { devWarn(`uiStorage: corrupted JSON for ${key}, clearing`, err); storageRemove(key, options); return null; }
}
